import { api } from "./axios";

export async function createNewBrand(data) {
    let res = await api.post("brand/store", data);
    if (res) return res.data.data;
    else return false;
}
export async function updateBrand(id, data) {
    let res = await api.post("brand/update/" + id, data);
    if (res) return res.data.data;
    else return false;
}
export async function getBrands() {
    let res = await api.get("brand/getAll");
    if (res) return res.data.data;
    else return false;
}

export async function getBrandsBySearch(searchData) {
    let res = await api.get("brand/search/" + searchData);
    if (res) return res.data.data;
    else return false;
}
export async function removeBrand(id) {
    let res = await api.get("brand/destroy/" + id);
    if (res) return res.data.data;
    else return false;
}

export async function getBrandsInRegisterModel() {
    let res = await api.get("website/brands");
    if (res) return res.data.data;
    else return false;
}